import { AppDispatch, RootState } from '@/store';
import { getProjectById } from '@/store/slices/projectsSlice/projectsSlice';
import { Expand } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const ProjectCard = ({ action, getEmoji, navigate }: any) => {
  const dispatch = useDispatch<AppDispatch>();

  const [opening, setOpening] = useState(false);

  const { loading, selected } = useSelector((state: RootState) => state.projects);

  useEffect(() => {
    if (opening && !loading && selected) {
      navigate('/dashboard/project-management/IndividualProject', {
        state: { project: selected },
      });
    }
  }, [opening, loading, selected, navigate]);

  const handleOpenProject = async () => {
    localStorage.setItem('selectedProjectId', action.id.toString());
    setOpening(true);
    dispatch(getProjectById(action.id));
  };

  const formatRole = (role: string | undefined) => {
    if (!role) return 'No Role';

    return role
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const handleEditProject = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate('/dashboard/project-management/EditProject', {
      state: { project: action },
    });
  };

  const roleName =
    action?.roleInfo?.name ??
    (() => {
      try {
        const storedRole = localStorage.getItem('roleInfo');
        return storedRole ? JSON.parse(storedRole)?.name : undefined;
      } catch {
        return undefined;
      }
    })();

  return (
    <div className="p-3 bg-[#F2EBEE] rounded-lg flex flex-col justify-between">
      <div className="flex justify-between mb-1">
        <div className="flex items-center gap-1">
          <div
            className={`
    project-card-status-outer flex items-center justify-center
    w-6 h-6 rounded-full border bg-[#F2EBEE]
    ${action.status ? 'border-green-400' : 'border-red-400'}
  `}
          >
            <div
              className={`
      project-card-status-inner w-4 h-4 rounded-full
      ${action.status ? 'bg-green-500' : 'bg-red-500'}
    `}
            ></div>
          </div>

          <h1 className="font-semibold">{action.id}</h1>
        </div>
        <div
          className={`
    px-2 rounded-xl flex items-center
   ${
     roleName === 'MANAGER'
       ? 'bg-[#CC167C]/80'
       : roleName === 'CONTENT_MODERATOR'
         ? 'bg-[#4C86E7CC]'
         : roleName === 'SURVEY_MANAGER'
           ? 'bg-[#E86A9BCC]'
           : roleName === 'ADMIN'
             ? 'bg-[#4CBEE7CC]'
             : roleName === 'SUPER_ADMIN'
               ? 'bg-[#CC167CCC]'
               : 'bg-[#5CC9A7CC]'
   }
  `}
        >
          <p className="text-xs font-medium text-[#1A0206]">{formatRole(roleName)}</p>
        </div>
      </div>
      <h3 className="text-2xl font-bold text-[#1A0206] mb-5 capitalize">{action.name}</h3>
      <div className="flex justify-between gap text-3xl">
        <div className="bg-[#AFAFAF]/50 w-[54px] h-[54px] rounded-lg flex items-center justify-center text-3xl">
          {getEmoji(action.emoji)}
        </div>

        {opening && loading ? (
          <div className="bg-[#AFAFAF]/20 p-3 rounded-lg w-[54px] h-[54px] flex items-center justify-center">
            <div className="w-5 h-5 border-2 border-[#1A0206] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : (
          <Expand
            onClick={handleOpenProject}
            className="bg-[#AFAFAF]/20 hover:bg-[#9e889580] cursor-pointer p-3 rounded-lg flex items-center justify-center"
            height={54}
            width={54}
            strokeWidth={1.5}
          />
        )}
      </div>
    </div>
  );
};

export default ProjectCard;
